import { toast } from "sonner";

class Toast {
    static success(message) {
        toast.success(message, {
            className: "!bg-green-700 !text-white !border !border-green-500 !shadow-lg !rounded-lg !p-4",
        });
    }

    static error(message) {
        toast.error(message, {
            className: "!bg-red-700 !text-white !border !border-red-500 !shadow-lg !rounded-lg !p-4",
        });
    }

    static warning(message) {
        toast.warning(message, {
            className: "!bg-yellow-700 !text-white !border !border-yellow-500 !shadow-lg !rounded-lg !p-4",
        });
    }

    static info(message) {
        toast.info(message, {
            className: "!bg-blue-700 !text-white !border !border-blue-500 !shadow-lg !rounded-lg !p-4",
        });
    }
}

export default Toast;